import { render, staticRenderFns } from "./select-input.vue?vue&type=template&id=55a7c857"
import script from "./select-input.vue?vue&type=script&lang=js"
export * from "./select-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.bun/vue-loader@15.11.1+1fd801dffddf8165/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports